import React from 'react'
import styles from './form-group.module.css'

const FormGroup = ({ label, children }) => {
    return <div className={styles.form_group}>
        {label && <p className={styles.form_group_label}>{label}</p>}
        {children}
    </div>
}

const FormGroupInline = ({ label, children }) => {
    return <div className={styles.form_group_inline}>
        {label && <label>{label}</label>}
        {children}
    </div>
}
const FormGroupInlineFluid = ({ label, children }) => {
    return <div className={styles.form_group_inline_fluid}>
        {label && <label>{label}</label>}
        {children}
    </div>
}

export { FormGroup, FormGroupInline, FormGroupInlineFluid }